import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _debounce from "lodash/debounce";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { cloneElement, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as CollapseIcon } from 'assets/icons/collapse-menu-arrow.svg';
import lendmateLogo from 'assets/images/lendmate-logo-black.svg';
import { useUser } from '../../../shared';
import { useNavigationControls } from '../NavigationContext';
import { sideNavContainer, menuListContainer, sideNavHeader, logoHolder, mobileBackdrop } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var MOBILE_BP = 768;

var MenuList = function MenuList(_ref) {
  var sideNavChildrens = _ref.sideNavChildrens,
      footer = _ref.footer,
      homeRoute = _ref.homeRoute,
      closeBreakPoint = _ref.closeBreakPoint;

  var _useUser = useUser(),
      tenant = _useUser.tenant;

  var location = useLocation();

  var _useNavigationControl = useNavigationControls(),
      setupSideNavControls = _useNavigationControl.setupSideNavControls;

  var initialMobile = window.innerWidth < MOBILE_BP;

  var _useState = useState(initialMobile),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var _useState3 = useState(!initialMobile && window.innerWidth >= closeBreakPoint),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(closeBreakPoint),
      _useState6 = _slicedToArray(_useState5, 2),
      breakPoint = _useState6[0],
      setBreakPoint = _useState6[1];

  var previousWidthRef = useRef(window.innerWidth);
  var isMobileRef = useRef(initialMobile); // Keep ref in sync with state (for use in debounced handler & effects)

  useEffect(function () {
    isMobileRef.current = isMobile;
  }, [isMobile]); // Sync controls + reactive isOpen into context

  useEffect(function () {
    setupSideNavControls({
      isOpen: isOpen,
      close: function close() {
        return setIsOpen(false);
      },
      open: function open() {
        return setIsOpen(true);
      },
      toggle: function toggle() {
        return setIsOpen(function (prev) {
          return !prev;
        });
      },
      changeBreakPoint: function changeBreakPoint(val) {
        return setBreakPoint(val);
      }
    });
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps
  // Close drawer on route change (mobile only)

  useEffect(function () {
    if (isMobileRef.current) setIsOpen(false);
  }, [location.pathname]);
  useEffect(function () {
    var handleWindowResize = _debounce(function (e) {
      var _e$currentTarget;

      var w = (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.innerWidth;
      var prev = previousWidthRef.current;
      var nowMobile = w < MOBILE_BP;
      var wasMobile = prev < MOBILE_BP;
      setIsMobile(nowMobile);
      isMobileRef.current = nowMobile;

      if (nowMobile && !wasMobile) {
        // Entered mobile: hide sidebar
        setIsOpen(false);
      } else if (!nowMobile && wasMobile) {
        // Left mobile: restore based on breakpoint
        setIsOpen(w >= breakPoint);
      } else if (!nowMobile) {
        // Tablet ↔ desktop transitions
        if (w < breakPoint && prev >= breakPoint) setIsOpen(false);else if (w >= breakPoint && prev < breakPoint) setIsOpen(true);
      }

      previousWidthRef.current = w;
    }, 300);

    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    setBreakPoint(closeBreakPoint);
    var mobile = window.innerWidth < MOBILE_BP;
    setIsMobile(mobile);
    setIsOpen(!mobile && window.innerWidth >= closeBreakPoint);
  }, [closeBreakPoint]);
  var MenuListItems = sideNavChildrens.map(function (menu, i) {
    return /*#__PURE__*/cloneElement(menu, {
      key: "".concat(menu.label, "-").concat(i),
      isOpen: isOpen,
      isMobile: isMobile
    });
  });
  var Footer = _isFunction(footer) && footer;
  return ___EmotionJSX(React.Fragment, null, isMobile && isOpen && ___EmotionJSX("div", {
    css: mobileBackdrop,
    role: "presentation",
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }), ___EmotionJSX("aside", {
    css: sideNavContainer(isOpen, isMobile),
    role: "navigation"
  }, ___EmotionJSX("header", {
    css: sideNavHeader(isOpen)
  }, ___EmotionJSX(Link, {
    to: homeRoute,
    className: "logo-container"
  }, ___EmotionJSX("div", {
    css: logoHolder((tenant === null || tenant === void 0 ? void 0 : tenant.logo_url) || lendmateLogo)
  })), ___EmotionJSX("span", {
    role: "menuitemcheckbox",
    tabIndex: "0",
    onClick: function onClick() {
      return setIsOpen(function (prev) {
        return !prev;
      });
    },
    "aria-checked": isOpen,
    className: "collapse-container"
  }, ___EmotionJSX(CollapseIcon, {
    className: "icon"
  }))), ___EmotionJSX("section", {
    className: "menu-list-container",
    css: menuListContainer
  }, MenuListItems), Footer && ___EmotionJSX(Footer, {
    isOpen: isOpen,
    setIsOpen: setIsOpen
  })));
};

MenuList.propTypes = {
  sideNavChildrens: PropTypes.array,
  footer: PropTypes.any,
  homeRoute: PropTypes.string,
  closeBreakPoint: PropTypes.number
};
export default MenuList;